/**
 * Colors_T61.jsx
 * Identity for B2C Template 61 — "Black Gold" Theme
 * Inspired by GT Holidays — bold Black + Gold premium adventure travel style.
 */
import { getLocalLogoUrl } from '../../Common/Utils/companyLogo';
export const mapB2CTenantToLanding = (tenantData) => {
  return {
    isPreview:   tenantData?.isPreview ?? false,
    companyId:   tenantData?.companyId,
    branchId:    tenantData?.branchId,
    userId:      tenantData?.userId,
     logoUrl: getLocalLogoUrl(tenantData?.domain),
    brandName:   tenantData?.branding?.brandName    || 'GT Travels',
    companyName: tenantData?.branding?.companyName  || 'GT Travels',
    email:       tenantData?.branding?.email        || 'info@gttravels.com',

    phones:      Array.isArray(tenantData?.branding?.phones)
                 ? tenantData?.branding?.phones[0]
                 : tenantData?.branding?.phones || '9000000000',

    whatsapp:    tenantData?.branding?.whatsapp  || '9000000000',
    socials:     tenantData?.branding?.socials   || {},
    companyData: tenantData?.companyData         || {},
    seo:         tenantData?.seo                 || {},

    themeColor1: tenantData?.theme?.themeColor1 || tenantData?.theme?.themecolor1,
    themeColor2: tenantData?.theme?.themeColor2 || tenantData?.theme?.themecolor2,
    themeColor3: tenantData?.theme?.themeColor3 || tenantData?.theme?.themecolor3,
    themeColor4: tenantData?.theme?.themeColor4 || tenantData?.theme?.themecolor4,
    themeColor5: tenantData?.theme?.themeColor5 || tenantData?.theme?.themecolor5,

    headerBgOverride:   tenantData?.header?.bgColor,
    headerTextOverride: tenantData?.header?.textColor,
    footerBgOverride:   tenantData?.footer?.bgColor,
    footerTextOverride: tenantData?.footer?.textColor,

    headingFont: tenantData?.branding?.headingFont || 'Montserrat',
    bodyFont:    tenantData?.branding?.bodyFont    || 'Inter',

    heroData:      tenantData?.hero,
    aboutUs:       tenantData?.aboutUs,
    contactUs:     tenantData?.contactUs,
    activeModules: tenantData?.activeModules,
  };
};

export const getB2CColors_T61 = (landingData) => {
  const black      = landingData?.themeColor1 || '#111111'; // Primary black
  const footerBlack= landingData?.themeColor2 || '#0a0a0a'; // Footer very dark
  const headerBg   = landingData?.themeColor3 || '#111111'; // Header black
  const gold       = landingData?.themeColor4 || '#f5b800'; // Gold/Yellow accent
  const pageBg     = landingData?.themeColor5 || '#f5f5f5'; // Light page background

  return {
    theme1: black,
    theme2: landingData?.footerBgOverride || footerBlack,
    theme3: landingData?.headerBgOverride || headerBg,
    theme4: gold,
    theme5: pageBg,
    gold,

    headerText: landingData?.headerTextOverride || '#ffffff',
    footerText: landingData?.footerTextOverride || '#cccccc',

    topBarBg:   '#000000',
    topBarText: '#ffffff',
  };
};

export const toRgba = (color, alpha = 1) => {
  if (!color || !color.startsWith('#')) return color;
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
